<div class="info-bar">
    <div class="counters">
        <em>{{ totalCount }} Search Results</em> | Filters ({{ appliedFiltersCount }})
    </div>
    <button *ngIf="filtersChanged" class="done" (click)="ngbActiveModal.close()">Done</button>
</div>
<div class="wrapper">
    <div *ngIf="!!searchInfo">
        <app-facets [syncFacets]="true" [premiumCollectionSearch]="!!searchInfo"></app-facets>
    </div>
    <div *ngIf="!searchInfo">
        <app-facets [syncFacets]="true"></app-facets>
    </div>
    <div class="see-all-wrapper">
        <button class="btn btn-primary text-white" (click)="ngbActiveModal.close()">
            <span *ngIf="filtersChanged">Done. See All {{ totalCount }} Search Results</span>
            <span *ngIf="!filtersChanged">Cancel</span>
        </button>
    </div>
</div>
